export const SubscriptionType = Object.freeze({
    EMAIL: 1,
    SMS: 2
});